import { api } from '../../helpers/Api';
var StretchPriceDates = /** @class */ (function () {
    function StretchPriceDates() {
    }
    StretchPriceDates.prototype.readDate = function (date, stretch_id) {
        return api.get("datePrices/date/".concat(stretch_id, "/").concat(date));
    };
    StretchPriceDates.prototype.readRange = function (dateFrom, dateTo, stretch_id) {
        return api.get("datePrices/daterange/".concat(stretch_id, "/").concat(dateFrom, "/").concat(dateTo));
    };
    // para recibir StretchPriceDates de un servicio a partir de una fecha (para no recibir precios anteriores a la fecha actual)
    StretchPriceDates.prototype.readStretch = function (afterDate, stretch_id) {
        return api.get("datePrices/afterDate/".concat(stretch_id, "/").concat(afterDate));
    };
    StretchPriceDates.prototype.saveDatePrices = function (data) {
        return api.post("datePrices/date", data);
    };
    return StretchPriceDates;
}());
export default StretchPriceDates;



//////////////////
// WEBPACK FOOTER
// ./src/modules/StretchPriceDates/Store.ts
// module id = 751
// module chunks = 0